import { MapVehicleRouteVM } from './mapVM';

/**
 * 地図に線を描くルート。
 *
 * 未選択のときは 1 本も描かない。全車両ぶんの線が重なると、どれがどの車両の
 * 経路なのか読めず地図が真っ黒になる（指示: 選択したものだけ表示）。
 *
 * 絞り込みは行（回転）単位。車両単位に広げていたときは、未配車の 2 回転目を
 * 選んでも 1 回転目の線が出て「1 回転目が選択されている」ように見えていた。
 */
export function resolveVisibleRoutes(
  routes: MapVehicleRouteVM[],
  selectedRowIds: ReadonlySet<string>,
): MapVehicleRouteVM[] {
  if (selectedRowIds.size === 0) return [];
  return routes.filter((r) => selectedRowIds.has(r.rowId));
}
